const dmrHomepageEditorConfig = {
  initialContent: {
    season_label: "",
    hero_title: "",
    hero_accent_title: "",
    hero_subtitle: "",

    primary_button_label: "",
    primary_button_link: "",
    secondary_button_label: "",
    secondary_button_link: "",

    features_eyebrow: "",
    features_title: "",
    feature_cards: [],

    hero_image_url: "",
  },

  imageFields: {
    hero: {
      contentKey: "hero_image_url",
    },
  },

  loadContent(content = {}) {
    return {
      ...this.initialContent,
      ...content,
      feature_cards: Array.isArray(content.feature_cards)
        ? content.feature_cards
        : [],
    };
  },

  buildContent(templateState = {}, sharedState = {}) {
    return {
      season_label: templateState.season_label?.trim() || "",
      hero_title: templateState.hero_title?.trim() || "",
      hero_accent_title:
        templateState.hero_accent_title?.trim() || "",
      hero_subtitle: templateState.hero_subtitle?.trim() || "",

      primary_button_label:
        templateState.primary_button_label?.trim() || "",
      primary_button_link:
        templateState.primary_button_link?.trim() || "",

      secondary_button_label:
        templateState.secondary_button_label?.trim() || "",
      secondary_button_link:
        templateState.secondary_button_link?.trim() || "",

      features_eyebrow:
        templateState.features_eyebrow?.trim() || "",
      features_title:
        templateState.features_title?.trim() || "",

      feature_cards: Array.isArray(templateState.feature_cards)
        ? templateState.feature_cards
        : [],

      hero_image_url: sharedState.resolvedHeroImageUrl || "",
    };
  },

  getStep2Props({
    templateState,
    setTemplateField,
    getImageField,
    setImageFile,
    setImageRemoved,
  }) {
    const hero = getImageField("hero");

    return {
      templateState,
      setTemplateField,

      heroImageFile: hero.file,
      setHeroImageFile: (file) =>
        setImageFile("hero", file),

      existingHeroImageUrl: hero.existingUrl,

      removeHeroImage: hero.remove,
      setRemoveHeroImage: (remove) =>
        setImageRemoved("hero", remove),
    };
  },
};

export default dmrHomepageEditorConfig;